import { EventSourceHandler } from '@sellsy/sse';

export default class DocpdfbgChangedEventSourceHandler extends EventSourceHandler {
    
    constructor(){
        super()
        this.type = 'corporation.docpdfbg.changed'
    }

    handle(event){
        if (window.location.pathname == '/') {
            let parts = this.URLToArray(window.location.search);
            if (parts._f && parts._f == 'prefsDocs' && parts.action && parts.action == 'layoutEdit' && parts.layoutid && parts.layoutid == event.data.layout_id) {
                $('#pdfBackgroundPreview img').attr('src', event.data.img_url);
                $('#pdfBackgroundPreview a').attr('href', event.data.file_url);
                $('#pdfBackgroundPreview').fadeIn();
                $('#previewLayout').css('background', 'url('+event.data.img_url+')');
            }
        }
    }

    URLToArray(url) {
        // should be in an helper
        var request = {};
        var pairs = url.substring(url.indexOf('?') + 1).split('&');
        for (var i = 0; i < pairs.length; i++) {
            if(!pairs[i])
                continue;
            var pair = pairs[i].split('=');
            request[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
         }
         return request;
    }

}
